import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.primary.color};
  padding: 0.75rem 0;

  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;

  * {
    line-height: 1;
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  @media (max-width: 991px) {
    padding: 1rem 0;

    img {
      max-width: 8.5rem;
    }
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  gap: 1.25rem;
  color: ${({ theme }) => theme.colors.white};
`;

export const ButtonAction = styled.button`
  svg {
    height: 1.0625rem;
    width: 1.0625rem;
    color: ${({ theme }) => theme.colors.white};
  }
`;
